import { CheckOutlined, CloseOutlined, SendOutlined } from '@ant-design/icons';
import { DonNghiPhep } from "@app/models/donnghiphep/DonNghiPhep";
import { hideLoadingScreen, showLoadingScreen } from "@app/store/reducers/loading";
import { Button, Col, Form, Input, Radio, Row, Space, Table, Tag } from "antd";
import { useForm } from 'antd/es/form/Form';
import Column from "antd/es/table/Column";
import { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";
import ModalTextForm from "../../components/modal/ModalTextForm";
import { trangThaiDonNghiPhep } from "../../constants";
import { Links } from "../../helpers/Links";
import { dateCommon, validateMessages } from "../../helpers/common";
import { duaYKienDonNghiPhep, duyetDonNghiPhep, huyDonNghiPhep, layDanhSachDonNghiPhepChoPheDuyet } from "../../services/donnghiphep";
const { TextArea } = Input;

const PheDuyetPhepTrangChu = () => {
    const dispatch = useDispatch();
    const [openModalDuyet, setOpenModalDuyet] = useState(false);
    const [openModalTuChoi, setOpenModalTuChoi] = useState(false);
    const [openModalDuyetHuy, setOpenModalDuyetHuy] = useState(false);
    const [openModalTuChoiHuy, setOpenModalTuChoiHuy] = useState(false);
    const [openModalYKien, setOpenModalYKien] = useState(false);
    const [lyDoTuChoi, setLyDoTuChoi] = useState<string>("");
    const [reload, setReload] = useState(false);
    const [formDuaYKien] = useForm();
    const [dsNghiPhep, setDsNghiPhep] = useState<Array<DonNghiPhep>>([]);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [idDonNghiPhep, setIdDonNghiPhep] = useState<number>(0);


    const layDsDuyetNghiPhep = async () => {
        setIsLoadingTable(true);
        var dataNghiPhep = await layDanhSachDonNghiPhepChoPheDuyet();
        setDsNghiPhep(dataNghiPhep.map((item: any, index: any) => {
            return { ...item, key: index }
        }));
        setIsLoadingTable(false);
    }

    const eventPheDuyetHuy = async (duyet: boolean) => {
        try {
            await huyDonNghiPhep({
                id: idDonNghiPhep,
                isDuyet: duyet,
                noiDung: lyDoTuChoi
            });
            toast.success("Phê duyệt yêu cầu hủy đơn nghỉ phép thành công.");
            setIdDonNghiPhep(0);
            setReload(true);
        } catch (error: any) {
            toast.error(error);
        }
    }


    const eventPheDuyet = async (duyet: boolean) => {
        try {
            await duyetDonNghiPhep({
                id: idDonNghiPhep,
                isDuyet: duyet,
                noiDung: lyDoTuChoi
            });
            toast.success("Phê duyệt đơn nghỉ phép thành công.");
            setIdDonNghiPhep(0);
            setReload(true);
        } catch (error: any) {
            toast.error(error);
        }
    }

    const onDuaYKien = async () => {
        formDuaYKien.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            try {
                await duaYKienDonNghiPhep({
                    id: idDonNghiPhep,
                    isDuyet: values.duyet,
                    noiDung: values.noiDung || ""
                });
                toast.success("Đưa ý kiến thành công.");
                setIdDonNghiPhep(0);
                setReload(true);
            } catch (ex: any) {
                toast.error(ex);
            }

            dispatch(hideLoadingScreen());
        }).catch(() => {

            dispatch(hideLoadingScreen());
        })
    }

    useEffect(() => {
        layDsDuyetNghiPhep();
    }, []);

    useEffect(() => {
        if (reload) {
            layDsDuyetNghiPhep();
            setReload(false);
        }
    }, [reload]);

    return (
        <>
            <Col xs={24} xl={24}>
                <Row style={{ marginBottom: "12px" }}>
                    <Col span="20">
                        <Row><b style={{ fontSize: "20px", color: "#071C50" }}>Đơn nghỉ phép chờ phê duyệt/ ý kiến</b></Row>
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%" }}>
                        <Table
                            pagination={false}
                            size="small"
                            loading={isLoadingTable}
                            locale={{ emptyText: "Không có dữ liệu" }}
                            dataSource={dsNghiPhep}
                            rowClassName={(record, index) => {
                                return (record?.id === idDonNghiPhep) ? "selected-row row-key-" : "";
                            }}
                        >
                            <Column
                                align="center"
                                title="STT"
                                key="STT"
                                width="46px"
                                render={(value, record: any, index) => (
                                    <>{index + 1}</>
                                )}
                            />
                            <Column
                                title="Nhân viên"
                                key="tenNhanVien"
                                render={(value: DonNghiPhep, record: any, index) => {
                                    return <Link
                                        style={{ fontWeight: "bold" }}
                                        to={Links.Phep.Xem + "?id=" + record.id}
                                    >
                                        {record.tenNhanVien}
                                    </Link>
                                }}
                            />
                            <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" />
                            <Column title="Loại nghỉ" dataIndex="tenLoaiNghiPhep" key="loaiNghiPhep" />
                            <Column
                                align="center"
                                title="Thời gian"
                                key="thoiGian"
                                width="180px" 
                                render={(value: DonNghiPhep, record: any, index) => (
                                    value.tuNgay == value.denNgay ?
                                        <>{dateCommon.formatDate(value.tuNgay)} </>
                                        : <>{dateCommon.formatDate(value.tuNgay)} - {dateCommon.formatDate(value.denNgay)} </>
                                )} />
                            <Column title="Lý do" dataIndex="lyDo" key="lyDo" />
                            <Column align="center" title="Trạng thái" width="120px" dataIndex="trangThai" key="trangThai" render={(value, record: any) => {
                                var tag = (<Link
                                    to={Links.Phep.Xem + "?id=" + record.id}><Tag color="default"></Tag></Link>);
                                switch (value) {
                                    case trangThaiDonNghiPhep.khoiTao: tag = (<Link
                                        to={Links.Phep.Xem + "?id=" + record.id}><Tag color="processing">Khởi tạo</Tag></Link>); break;
                                    case trangThaiDonNghiPhep.trinh: tag = (<Link
                                        to={Links.Phep.Xem + "?id=" + record.id}><Tag color="warning">Trình Lãnh đạo</Tag></Link>); break;
                                    case trangThaiDonNghiPhep.daDuyet: tag = (<Link
                                        to={Links.Phep.Xem + "?id=" + record.id}><Tag color="success">Đã Duyệt</Tag></Link>); break;
                                    case trangThaiDonNghiPhep.tuChoi: tag = (<Link
                                        to={Links.Phep.Xem + "?id=" + record.id}><Tag color="error">Từ chối</Tag></Link>); break;
                                    case trangThaiDonNghiPhep.yKien: tag = (<Link
                                        to={Links.Phep.Xem + "?id=" + record.id}><Tag color="orange">Lấy ý kiến</Tag></Link>); break;
                                    case trangThaiDonNghiPhep.yeuCauHuy: tag = (<Link
                                        to={Links.Phep.Xem + "?id=" + record.id}><Tag color="cyan">Yêu cầu hủy</Tag></Link>); break;
                                    case trangThaiDonNghiPhep.daHuy: tag = (<Link
                                        to={Links.Phep.Xem + "?id=" + record.id}><Tag color="error">Đã hủy</Tag></Link>); break;
                                    case undefined: tag = (<></>);
                                }
                                return tag;
                            }} />
                            <Column align="center" width="120px" dataIndex="trangThai" key="thaotac" render={(value, record: any) => {
                                var btn = (<Space></Space>);
                                switch (value) {
                                    case trangThaiDonNghiPhep.trinh: btn = (<Space >
                                        <Button size="small" type="primary" className="float-right hrm-btn-delete" htmlType="button" icon={<CloseOutlined rev="" />}
                                            onClick={() => {
                                                setIdDonNghiPhep(record.id);
                                                setLyDoTuChoi("");
                                                setOpenModalTuChoi(true);
                                            }}
                                        >
                                            Không duyệt
                                        </Button>
                                        <Button size="small" type="primary" className="float-right" htmlType="button" icon={<CheckOutlined rev="" />}
                                            onClick={() => {
                                                setIdDonNghiPhep(record.id);
                                                setLyDoTuChoi("");
                                                setOpenModalDuyet(true);
                                            }}>
                                            Duyệt
                                        </Button>
                                    </Space>); break;
                                    case trangThaiDonNghiPhep.yKien:
                                        btn =
                                            <Button
                                                size= "small"
                                                type="primary"
                                                icon={<SendOutlined rev="" />}
                                                onClick={() => {
                                                    setIdDonNghiPhep(record.id);
                                                    formDuaYKien.setFieldValue('duyet', true);
                                                    formDuaYKien.setFieldValue('noiDung', "");
                                                    setOpenModalYKien(true);
                                                }}
                                            >
                                                Đưa ý kiến
                                            </Button>; break;
                                    case trangThaiDonNghiPhep.yeuCauHuy: btn = (<Space >
                                        <Button size="small" type="primary" className="float-right hrm-btn-delete" htmlType="button" icon={<CloseOutlined rev="" />}
                                            onClick={() => {
                                                setIdDonNghiPhep(record.id);
                                                setLyDoTuChoi("");
                                                setOpenModalTuChoiHuy(true);
                                            }}
                                        >
                                            Từ chối
                                        </Button>
                                        <Button size="small" type="primary" className="float-right" htmlType="button" icon={<CheckOutlined rev="" />}
                                            onClick={() => {
                                                setIdDonNghiPhep(record.id);
                                                setLyDoTuChoi("");
                                                setOpenModalDuyetHuy(true);
                                            }}>
                                            Đồng ý
                                        </Button>
                                    </Space>); break;
                                    default: break;
                                }
                                return btn;
                            }} />
                        </Table>
                    </div>
                </Row>
            </Col>
            {openModalDuyet && <ModalTextForm show={openModalDuyet}
                title="Đồng ý phê duyệt đơn nghỉ phép"
                handleClose={() => { setIdDonNghiPhep(0); setOpenModalDuyet(false) }}
                handleSave={() => { eventPheDuyet(true); setOpenModalDuyet(false); }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Đồng ý </label> phê duyệt đơn nghỉ phép đang chọn không? Hãy nhập nội dung (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalTuChoi && <ModalTextForm show={openModalTuChoi}
                title="Từ chối phê duyệt đơn nghỉ phép"
                handleClose={() => {
                    setIdDonNghiPhep(0);
                    setOpenModalTuChoi(false);
                }}
                handleSave={() => {
                    eventPheDuyet(false);
                    setOpenModalTuChoi(false);
                }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Từ chối</label> phê duyệt đơn nghỉ phép đang chọn không? Hãy nhập lý do (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalDuyetHuy && <ModalTextForm show={openModalDuyetHuy}
                title="Đồng ý hủy đơn nghỉ phép"
                handleClose={() => { setIdDonNghiPhep(0); setOpenModalDuyetHuy(false) }}
                handleSave={() => { eventPheDuyetHuy(true); setOpenModalDuyetHuy(false); }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Đồng ý </label> phê duyệt yêu cầu hủy đơn nghỉ phép đang chọn không? Hãy nhập nội dung (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalTuChoiHuy && <ModalTextForm show={openModalTuChoiHuy}
                title="Từ chối hủy đơn nghỉ phép"
                handleClose={() => {
                    setIdDonNghiPhep(0);
                    setOpenModalTuChoiHuy(false);
                }}
                handleSave={() => {
                    eventPheDuyetHuy(false);
                    setOpenModalTuChoiHuy(false);
                }}>
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Từ chối</label> yêu cầu hủy đơn nghỉ phép đang chọn không? Hãy nhập lý do (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea rows={2} value={lyDoTuChoi} onChange={(e) => { setLyDoTuChoi(e.target.value); }} />
                    </Col>
                </Row>
            </ModalTextForm>}
            {openModalYKien && <ModalTextForm show={openModalYKien}
                title="Đưa ý kiến cho đơn nghỉ phép đang chọn"
                handleClose={() => {
                    setIdDonNghiPhep(0);
                    setOpenModalYKien(false)
                }}
                handleSave={() => {
                    onDuaYKien();
                    setOpenModalYKien(false);
                }}>
                <Form
                    form={formDuaYKien}
                    onFinish={() => { }}
                    validateMessages={validateMessages}
                >
                    <Form.Item label="Ý kiến" name="duyet" rules={[{ required: true }]}>
                        <Radio.Group>
                            <Radio value={true}>Đồng ý</Radio>
                            <Radio value={false}>Từ chối</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        label="Nội dung ý kiến"
                        name="noiDung"
                    >
                        <TextArea placeholder="Nội dung" />
                    </Form.Item>
                </Form>
            </ModalTextForm>}
        </>
    )
}

export default PheDuyetPhepTrangChu;